// components/Handbook.jsx
import SignImg from "../image/guidstamp.png";
export default function Handbook() {
  return (
    <div className="px-10 py-4 mx-5 text-justify font-sans text-sm leading-relaxed text-gray-800 space-y-4">
      <p className="text-center font-bold text-base underline">
        (Employee Code of Conduct/ Ethics policy Document)
      </p>
      <p className="font-semibold">DYC Global Inspections Pvt Ltd</p>

      <p className="font-bold">1. Purpose of this Handbook:</p>
      <p>
        This handbook has been prepared to inform new employees of the policies
        and procedures of DYC Global Inspections Pvt. Ltd. and to establish the
        company’s expectations. It is not all inclusive or intended to provide
        strict interpretations of our policies; rather, it offers an overview of
        the work environment. This handbook is not a contract, expressed or
        implied, guarantying employment for any length of time and is not
        intended to indu ce an employee to accept employment with the company.
        <br />
        <br />
        The company reserves the right to unilaterally revise, suspend, revoke,
        terminate or change any of its policies, in whole or in part, whether
        described within this handbook or elsewhere, in its sole discretion. If
        any discrepancy between this handbook and current company policy arises,
        conform to current company policy. Every effort will be made to keep you
        informed of the company’s policies. Feel free to ask questions about any
        of the information within this handbook
      </p>

      <p className="font-bold">2. History, Goals & Culture:</p>
      <p>
        <i className="underline font-medium">
          About DYC Global Inspections Pvt Ltd
        </i>
        <br />
        <br />
        DYC Global Inspections Pvt Ltd provides inspection, expediting, NDT
        services and industrial consulting services to various clients in India&
        aboard. With its expertise in offering Individual solutions based on
        customer's requirements, DYC Global is making its mark in various
        segments which includes Oil & Gas (offshore installations as well as
        onshore refineries), Petrochemical Chemical, Fertilizer, Power, Steel,
        Infrastructure & many more.
        <br />
        <br />
        We are having associates within various states of India as well as
        Italy, Germany, UK and Malaysia.
      </p>

      <p className="font-bold">Our Vision</p>
      <p>
        Our vision is to be expert service provider in the field of inspection,
        expediting & training in enabling industries & business to achieve
        highest performance whilst assuring excellence and quality, ethics,
        integrity, health, safety & environment with social consciousness &
        commitment in the delivery of their products and our services.
      </p>

      <p className="font-bold">Quality Policy</p>
      <p>
        DYC Global Inspections Pvt Ltd is committed to provide third party
        inspection, expediting and training services by;
      </p>
      <ol className="list-decimal ml-8 space-y-1">
        <li>
          Consistently meeting and exceeding customer’s expectations of service
          quality and performance.
        </li>
        <li>
          Timely completion of services to meet our customer’s requirements
          within affordable cost
        </li>
        <li>
          Continuous improvement of our processes and systems by using advanced
          techniques
        </li>
      </ol>

      <p className="font-bold">3. Hierarchy DYC Global Inspections Pvt Ltd:</p>
      <p></p>

      <p className="font-bold">4. Equal Opportunity Employment</p>
      <p>
        This company is an equal opportunity employer and does not unlawfully
        discriminate against employees or applicants for employment on the basis
        of an individual’s race, colour, religion, creed, sex, national origin,
        age, disability, marital status, veteran status or any other status
        protected by applicable law. This policy applies to all terms,
        conditions and privileges of employment, including recruitment, hiring,
        placement, compensation, promotion, discipline and termination.
      </p>

      <p className="font-bold">5. Policy Against Workplace Harassment</p>
      <p>
        This company prohibits discrimination or harassment based on race,
        colour, religion, creed, sex, national origin, age, disability, marital
        status, veteran status or any other status protected by applicable law.
        Each individual has the right to work in a professional atmosphere that
        promotes equal employment opportunities and is free from discriminatory
        practices, including without limitation harassment. Consistent with its
        workplace policy of equal employment opportunity, the company prohibits
        and will not tolerate harassment on the basis of race, colour, religion,
        creed, sex, national origin, age, disability, marital status, veteran
        status or any other status protected by applicable law. Violations of
        this policy will not be tolerated.
        <br />
        <br />
        Discrimination includes, but is not limited to: making any employment
        decision or employment related action on the basis of race, colour,
        religion, creed, age, sex, disability, national origin, marital or
        veteran status, or any other status protected by applicable law.
        <br />
        <br />
        Sexual harassment is defined as unwelcome sexual advances, requests for
        sexual favours and other verbal, visual or physical conduct of a sexual
        nature, when:
      </p>
      <ol className="list-decimal ml-8 space-y-1">
        <li>
          Submission to such conduct is made either explicitly or implicitly a
          term or condition of an individual’s employment;
        </li>
        <li>
          Submission to or rejection of such conduct by an individual is used as
          the basis for employment decisions affecting such individual; or
        </li>
        <li>
          Such conduct has the purpose or effect of unreasonably interfering
          with an individual’s work performance or creating an intimidating,
          hostile or offensive working environment.
        </li>
      </ol>

      <p className="font-bold">6. Type Of Employments</p>
      <ul className="list-inside ml-4 space-y-2">
        <li>Definition of Terms:</li>
        <li>Employer:</li>
        <li>
          The DYC Global is the employer of all full-time part-time and
          temporary employees. An employee is hired, provided compensation and
          applicable benefits, and has his or her work directed and evaluated by
          DYC Global.
        </li>
        <li>
          On payroll employee: A Full Time Employee regularly works at 6 day a
          week.
        </li>
        <li>
          Contract Employee: They are often considered to be self-employed, and
          have the freedom to pick and choose their projects and companies they
          would like to be associated with
        </li>
      </ul>

      <p className="font-bold">7. Hours Of Work, Attendance And Punctuality</p>
      <ol
        className="ml-9 space-y-2"
        style={{ listStyleType: "disclosure-closed" }}
      >
        <li>
          Employees who on client location they have to follow working timing as
          per the client companies norms.
        </li>
      </ol>

      <p className="font-bold">8. Dress Code and Public Image</p>
      <ol
        className="ml-9 space-y-2"
        style={{ listStyleType: "disclosure-closed" }}
      >
        <li>Employees should wear clean, ironed and neat clothes.</li>
        <li>
          Keep your hair neat, nails trimmed, and maintain good personal
          hygiene.
        </li>
      </ol>

      <p className="font-bold">9. Attendance and Punctuality</p>
      <p>
        It is important for you to report to work on time and to avoid
        unnecessary absences. The Company recognizes that illness or other
        circumstances beyond your control may cause you to be absent from work
        from time to time. However, frequent absenteeism or tardiness may result
        in disciplinary action, up to and including discharge. Excessive
        absenteeism or frequent tardiness can have a negative impact on the
        success of the Company.
      </p>

      <p className="font-bold">10. Workspace</p>
      <p>
        Employees should keep in mind that their workspace is part of a
        professional environment that portrays the Company’s overall dedication
        to providing quality service to its clients. Therefore, your workspace
        should be clean, organized and free of items that are not required to
        perform your job.
      </p>

      <p className="font-bold">11. Company Property</p>
      <ol className="ml-9 space-y-2" style={{ listStyleType: "decimal" }}>
        {" "}
        <li>
          For Inspection Client company provide their hard and soft stamp to
          Engineer. Employees have to use stamp only for official use. Personal
          use of the stamps is illegal.{" "}
        </li>
        <li>
          Employees have to returns client companies property after completion
          of project or Employment.
        </li>
        <li>
          Employees are reminded that they should have no expectation of privacy
          in their use of company computers or other equipment.
        </li>
        <li>
          Employees are reminded that they should have no expectation of privacy
          in their use of company computers or other electronic equipment.
        </li>
        <li>
          Violations of these policies could result in disciplinary action.
        </li>
      </ol>

      <p className="font-bold">12. Personnel Files</p>
      <p>
        The company maintains a personnel file on each employee. These files are
        kept Confidential to the extent possible. Employees may review their
        personnel file upon Request. It is important that personnel files
        accurately reflect each employee’s personal Information. Employees are
        expected to inform the company of any change in name, Address, home
        phone number, home address, marital status, number of dependents or
        emergency contact information
      </p>

      <p className="font-bold">13. Workplace Safety</p>
      <p>
        Employees should use all safety and protective equipment provided to
        them, and maintain work areas in a safe and orderly manner, free from
        hazardous conditions. Employees who observe an unsafe practice or
        condition should report it to a supervisor or concern person. Employees
        are prohibited from making threats against anyone in connection with
        his/her work or engaging in violent activities while in the employ of
        the company.
        <br />
        <br />
        Employees are encouraged to always remain aware of their surroundings
        and to exercise caution while traveling. Prioritize safety by utilizing
        trusted transportation and accommodations. Stay informed about potential
        risks and adhere to company travel guidelines at all times.
      </p>

      <p className="font-bold">14. Compensation and Benefits</p>
      <p>
        Compensation is the monetary benefit which is given to an employee or
        worker giving their services to an organization. Compensation includes
        components like salary, wages, bonuses etc. The compensation provided
        helps in motivating the employees, build their career and ensure that
        there are committed in achieving the company goals.
      </p>

      <p className="font-bold">Deductions:</p>
      <p>
        TDS of Contract Employee are deducted as per law. They get certificates
        also for the same.
      </p>

      <p className="font-bold">15. Exit Policy</p>
      <p>
        Valuable feedback concerning streamlining and strengthening processes to
        improve employee engagement and retention can be obtained during the
        Exit Interview. The Exit Interview is designed to solicit ideas,
        suggestions and experience of employees leaving the company as to how
        DYC Global Inspections may be made better place to work.
        <br />
        <br />
        For more details refer separate “Exit policy”.
        <br />
        <br />
        If you have any questions regarding any of the policy guidelines listed
        above, please contact HR Dept.
      </p>
      <hr className="my-4 border-gray-400" />
      <p className="font-bold text-center">
        Quality, Health, Safety & Environment Policy
      </p>
      <p>
        We at DYC Global Inspections Pvt Ltd believe that our Business
        Sustenance depends on our continued quality of services while protecting
        People and the Environment.
        <br />
        <br />
        We are committed to meet our Clients’ Quality expectations also along
        with Safe and Healthy Environment.
        <br />
        <br />
        In view of this Vision, we consistently keep below Mission activities in
        our focus:
      </p>
      <ol className="ml-5 space-y-1" style={{ listStyleType: "disc" }}>
        {" "}
        <li>
          Recruiting competent Engineers who are Safety Conscious and
          demonstrate their respect towards Health and Environment
        </li>
        <li>Minimizing adverse impact of our activities to the Environment.</li>
        <li>
          Optimum utilization of Energy, Machinery, Finance and other resources
        </li>
        <li>
          Strong Organizational Support through human resource development for
        </li>
        Emergency Preparedness.
        <li>Provision of Safe working environment for prevention of injury.</li>
        <li>
          Communicating openly with Client’s and Vendors for making them aware
          of
        </li>
        QHSE aspects of our activities
        <li>Compliance with Client’s agreed Procedures and Systems</li>
        <li>Compliance of applicable Legal and other requirements.</li>{" "}
      </ol>

      <p className="text-right font-semibold">
        <img src={SignImg} alt="Signature"     className="h-16 mb-2 ml-auto" />
        Ramesh S. Jadhav
        <br />
        Chief Executive Officer
        <br />
        1st September 2020
      </p>

      {/* <hr className="my-4 border-gray-400" />

      <p className="font-bold underline text-center">Declaration by Employee</p>
      <p>
        This is to confirm that I have read DYC Global Employee handbook
        thoroughly & agree for the same. I hereby confirm to abide by DYC Global
        norms & policies declared time to time.
      </p>

      <div className="space-y-2 mt-4">
        <p>
          <strong>Employee Name –</strong> 
        </p>
        <p>
          <strong>Employee Designation –</strong> 
        </p>
        <p>
          <strong>Joining Date –</strong> 
        </p>
        <p>
          <strong>Contact No –</strong> 
        </p>
      </div>
      <br/>

        <div className="flex justify-between mt-10 pt-10">
          <div>
            <p className="font-semibold text-black">Employee Signature</p>
            <br />
            <p className="font-semibold text-sm"></p>
            <p className="font-semibold text-sm"></p>
          </div>
          <div>
            <p className="font-semibold text-black">Approved and Reviewed</p>
            <br />

            <img src={SignImg} />
            <p className="font-semibold text-sm">Mr. Ramesh Jadhav- CEO</p>
            <p className="font-semibold text-sm"> </p>
          </div>
        </div> */}
    </div>
  );
}
